import { render, staticRenderFns } from "./ProductPPdata.vue?vue&type=template&id=09d7b1f8&"
import script from "./ProductPPdata.vue?vue&type=script&lang=js&"
export * from "./ProductPPdata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports